const resizeScreenObserver = {
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};

export default resizeScreenObserver;



// WEBPACK FOOTER //
// ./src/uikit/components/AppModal/mixins/resizeScreenObserver.ts